<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">角色名：</span>
        </div>
        <el-input v-model="formData.name" :maxlength="32" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox" style="vertical-align: top;">
          <b class="red">*</b>
          <span class="line-text">角色权限：</span>
        </div>
        <div style="display: inline-block;width: 280px;height: 250px;overflow: auto;">
          <el-tree :props="defaultProps" accordion :check-strictly="roleAuthModifyTreeCheckStrictly" node-key="id" ref="roleAuthModifyTree"
                   :data="authTreeData" show-checkbox @check-change="handleCheckChange">
          </el-tree>
        </div>
      </div>
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--&lt;!&ndash;<b class="red">*</b>&ndash;&gt;-->
          <!--<span class="line-text">楼栋权限：</span>-->
        <!--</div>-->
        <!--<el-select v-model="formData.buildingCodes" multiple placeholder="请选择" size="mini" style="width: 280px">-->
          <!--<el-option-->
            <!--v-for="item in buildingList"-->
            <!--:key="item.code"-->
            <!--:label="item.name"-->
            <!--:value="item.code">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {jurisdiction} from '../../../utils/jurisdiction'
import {api} from '../../api/role'
import {errorHandler} from '../../../utils/errorHandler'
import {nError, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'
import {pattern} from '../../../utils/regular'

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'role-add',
  data () {
    return {
      breadcrumb: [{
        value: '资源中心',
        name: 'yq-information'
      }, {
        value: '角色管理'
      }],
      mainTitle: '修改角色',
      subheading: '修改平台账户的访问权限',
      roleAuthModifyTreeCheckStrictly: true,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      buildingList: [],
      authTreeData: [],
      formData: {
        code: '',
        name: '',
        buildingCodes: [],
        permissionCodes: []
      }
    }
  },
  created () {
    this.formData.code = this.$route.params.id
    let authTreeData = this.deepClone(jurisdiction)
    let currentPermissionCodes = bus.global.permissionCodes
    let newFirstCodes = []
    authTreeData.map(vFirst => {
      let newSecondCodes = []
      vFirst.children.map(vSecond => {
        let newThirdCodes = []
        if (vSecond.children) {
          vSecond.children.map(vThird => {
            if (currentPermissionCodes.indexOf(vThird.id) !== -1) {
              newThirdCodes.push(vThird)
            }
          })
          vSecond.children = newThirdCodes
        }
        if (currentPermissionCodes.indexOf(vSecond.id) !== -1) {
          newSecondCodes.push(vSecond)
        }
      })
      vFirst.children = newSecondCodes

      if (vFirst.id === '000000000') {
        newFirstCodes.push(vFirst)
      } else if (newSecondCodes.length !== 0) {
        newFirstCodes.push(vFirst)
      }

    })
    this.authTreeData = newFirstCodes
    this.getRoleByCode()
    // this.getBuildingList()
  },
  methods: {
    // 获取单个角色信息
    getRoleByCode () {
      this.$axios.post(`${api.getRoleByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.formData.name = data.name
            this.formData.buildingCodes = data.buildingCodes
            if (data.permissionCode) {
              this.formData.permissionCodes = data.permissionCode.split(',')
            }
            let permissionCodes = []
            this.formData.permissionCodes.map(v => {
              permissionCodes.push(v)
            })
            this.$refs.roleAuthModifyTree.setCheckedKeys(permissionCodes)
            setTimeout(() => {
              this.roleAuthModifyTreeCheckStrictly = false
            }, 500)
          }
        })
        .catch(errorHandler('获取角色列表失败'))
    },
    // 获取楼栋列表
    getBuildingList() {
      // let accountName = bus.global.accountName
      // this.$axios.post(`${api.getBuildingList}/${accountName}`, {})
      this.$axios.post(api.getBuildingList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.buildingList = data
          }
        })
        .catch(errorHandler('获取楼栋信息失败'))
    },
    toRoleManagementPage () {
      this.$router.push({
        name: 'role-management'
      })
    },
    handleCheckChange (data, checked, childChecked) {
      let checkedList = this.$refs.roleAuthModifyTree.getCheckedNodes(false, true)
      let permissionCodes = []
      checkedList.map(v => {
        if (v.id) {
          permissionCodes.push(v.id)
        }
      })
      this.formData.permissionCodes = permissionCodes
    },
    // 确认
    confirm () {
      let checkName = pattern.characterInput_24.test(this.formData.name)
      if (!this.formData.name) {
        nError('请输入角色名')
        return false
      } else {
        if (!checkName) {
          nError('角色名不允许有特殊字符或空格')
          return false
        }
      }
      if (this.formData.permissionCodes.length === 0) {
        nError('请选择角色权限')
        return false
      }
      // if (this.formData.buildingCodes.length === 0) {
      //   nError('请选择楼栋权限')
      //   return false
      // }
      // this.formData.permissionCodes.map(v => {
      //   if (v !== '000000000') {
      //     let str = v.slice(0, 3)
      //     if (this.formData.permissionCodes.indexOf(str) === -1 && str !== '009' ) {
      //       this.formData.permissionCodes.push(str)
      //     }
      //   }
      // })
      this.formData.currentAccountPermissionCodes = bus.global.permissionCodes
      this.$axios.post(api.update, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.toRoleManagementPage()
          }
        })
        .catch(errorHandler('修改失败'))
    },
    cancel () {
      this.toRoleManagementPage()
    },

    // 深拷贝对象
    deepClone(obj) {
      var o;
      // 如果  他是对象object的话  , 因为null,object,array  也是'object';
      if (typeof obj === "object") {
        // 如果  他是空的话
        if (obj === null) {
          o = null;
        } else {
          // 如果  他是数组arr的话
          if (obj instanceof Array) {
            o = [];
            for (let i = 0, len = obj.length; i < len; i++) {
              o.push(this.deepClone(obj[i]));
            }
          } else {
            // 如果  他是对象object的话
            o = {};
            for (let j in obj) {
              o[j] = this.deepClone(obj[j]);
            }
          }
        }
      } else {
        o = obj;
      }
      return o;
    },
  }
}
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/RoleManagement/RoleModify.vue